module.exports = __webpack_public_path__ + "img/far_night_cyl125_axis90.29a48843.jpg";